export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_9407_SHOW_LESS': 'Show Less',
    '_9408_SHOW_MORE': 'Show More',
    '_7310_SESSION_DATE': 'Session Date',
    '_7334_BEHAVIOUR': 'Behaviour',
    '_7336_SUB_BEHAVIOUR': 'Tactic',
    '_7339_METRIC_NAME': 'Metric Name',
    '_9473_DAYS_ACTIVE': 'Days Active',
    '_4106_CURRENT_ACTUAL': 'Current Actual',
    '_768___TO_TARGET': '% to Target',
    '_7367___TO_GOAL': '% To Goal',
    '_9402_NA': 'NA',
    '_8_COACHING': 'Coaching',
    '_9916_MY_COACHING': 'My Coaching',
    '_10060_ALIGNED': 'Aligned',
    '_10061_GOALED_KPI': 'Goaled KPI',
    '_10062_PERCENT_IMPROVEMENT': '% Improvement',
    '_9923_LAST_UPDATED': 'Last Updated',
    '_10063_DAYS_AS_AN_OPPORTUNITY': 'Days As An Opportunity',
    '_10064_PENDING_COMMITMENTS': 'Pending Commitments',
    '_10065_ACTIVE_PLANS': 'Active Plans',
    '_10066_OTHER_OPPORTUNITIES': 'Other Opportunities',
    '_10067_RESET_CARD_TO_DEFAULT_VIEW': 'Reset card to default view',
    '_10068_EXPAND_TO_COACHING_INSIGHT': 'Expand to Coaching Insight',
    '_10071_THERE_ARE_NO_COACHING_PLANS_CURRENTLY_ACTIVE': 'There are no coaching plans currently active',
    '_10072_THERE_ARE_NO_UNCOACHED_OPPORTUNITIES': 'There are no uncoached opportunities'
};
